<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-12 20:12:35
 * @LastEditors: lwq
 * @LastEditTime: 2021-05-06 14:08:39
 * @FilePath: \web_admin\src\LAYOUT\logo.vue
-->
<template>
  <div class="d-flex">
    <div style="width:239px;overflow:hidden" class="py-2 pl-6">
      <!-- <v-list-item style="height:56px"> -->
      <!-- <mrc_ess_svgIcon icon-class="logoV1_ESSEnterprise_full_e_blue"
                         :style="{fontSize: '150px'}" /> -->

      <!-- ,transform: miniVariant ? 'scale(1.4)' : 'scale(1)' -->
      <!-- <v-list-item-content>
          <v-list-item-title class="title"
                             style="color: #000000">

            <span style="font-size: 16px;overflow:hidden">Essence HR Platform - Admin</span>
          </v-list-item-title>
        </v-list-item-content> -->
      <!-- </v-list-item> -->
      <!-- company_logo_addr -->
      <v-img
        :src="img"
        height="40px"
        width="150px"
        @click="toHome"
        style="cursor:pointer"
        aspect-ratio="1.7"
        contain
      ></v-img>
    </div>
    <v-divider vertical style="background-color:#dedede;"></v-divider>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { getCompanyLogo } from "@/service/api/company_set.js"
import img from "@/assets/img/logo.png"
export default {
  components: {},
  props: {},
  data() {
    return {
      img: img,
    }
  },
  validations: {},
  computed: {},
  created() {},
  watch: {},
  mounted() {
    // 获取公司头像
    this.getLogo()
    // console.log(this.$store.state.userData.company_logo_addr ? this.$store.state.userData.company_logo_addr : img);
  },
  beforeRouteUpdate() {},
  methods: {
    toHome() {
      this.$router.push({
        path: "/dashboard",
      })
    },
    getLogo() {
      getCompanyLogo()
        .then((res) => {
          if (res.code == 200 && res.data && !Array.isArray(res.data)) {
            this.img = res.data
          } else {
            this.img = img
          }
        })
        .catch((err) => {
          this.img = img
        })
    },
  },
}
</script>

<style scoped></style>
